<template>
    <div :title="`Bewertung: ${rating} von ${max}`">
        <span class="mdi mdi-star" v-for="n in fullStars" :key="n"></span><span class="mdi mdi-star-half" v-for="n in halfStars" :key="n"></span><span class="mdi mdi-star-outline" v-for="n in emptyStars" :key="n"></span>
    </div>
</template>

<script>
    export default {
        props: {
            rating: {
                type: Number,
                required: true,
            },
            max: {
                type: Number,
                default: 5,
            },
        },

        computed: {
            precise() {
                return Math.floor(this.rating * 2);
            },

            fullStars() {
                return Math.floor(this.precise / 2);
            },

            halfStars() {
                return this.precise % 2 ? 1 : 0;
            },

            emptyStars() {
                return Math.floor((10 - this.precise) / 2);
            },
        },
    };
</script>
